
<template>
    <div class="center examplex permisos">
        <div class="encabezado" v-if="agrupar">
            <h6 class="mb-0">{{agrupar == 'docente' ? 'DOCENTE' : 'CÓDIGO DE SESIÓN'}}</h6>
        </div>
        <p class="sinInfo" v-if="!informacion[0]">Sin información</p>
        <details 
            :key="index"
            v-for="(tr, index) in informacion"
            class="divisionLineas"
            v-else
        >
            <summary>
				<span><i class="fas fa-caret-down"></i></span>
                <div>
                    <h5 class="mb-0">
                        <strong class="text-uppercase">{{tr.nombre}}</strong>
                    </h5>
                </div>
            </summary>
            <vs-row>
                <vs-col class="ml-auto" sm="12" lg="3">
                    <vs-input class="ml-auto" v-model="search[index]" placeholder="Buscar">
                        <template #icon>
                            <i class="fas fa-search"></i>
                        </template>
                    </vs-input>
                </vs-col>
            </vs-row>
            <vs-row class="mb-5">
                <vs-col sm="12" lg="4" v-for="(info, i) in $vs.getSearch(tr.info, search[index])" :key="i" >
                    <div class="cardDiv shadow-sm">
                        <p class="mb-0"><small>{{agrupar == 'docente' ? 'CÓDIGO DE SESIÓN' : 'DOCENTE' }}</small></p>
                        <h5 class="text-uppercase"><strong>{{agrupar == 'docente' ? info.materia : info.profesor}}</strong></h5>
                        <hr class="my-3 hrDot">
                        <div class="d-flex justify-content-between">
                            <div>
                                <p class="mb-0"><small>GRUPO ACADÉMICO</small></p>
                                <p class="mb-0"><strong>{{info.grupo}}</strong></p>
                            </div>
                            <div>
                                <md-chip class="'mini-chip col-green"><small>NO. ALUMNOS: </small><strong>{{info.no_alumnos}} </strong></md-chip>
                            </div>
                        </div>
                        <hr class="my-3 hrDot">
                        <div class="d-flex justify-content-between">
                            <div>
                                <p class="mb-0"><small>EDIFICIO</small></p>
                                <p class="mb-0"><strong>{{info.edificio}}</strong></p>
                            </div>
                            <div>
                                <p class="mb-0"><small>AULA</small></p>
                                <p class="mb-0"><strong>{{info.aula}}</strong></p>
                            </div>
                        </div>
                        <hr class="my-3 hrDot">
                        <div class="d-flex justify-content-between">
                            <div>
                                <p class="mb-0"><small>HORARIO</small></p>
                                <p class="mb-0"><strong>{{getDays(info.dias)}} de {{info.horario_inicio}} a {{info.horario_fin}}</strong></p>
                            </div>
                        </div>
                    </div>
                </vs-col>
            </vs-row>
        </details>
    </div>
</template>
<script>
export default {
    props:[
        'users',
        'agrupar'
    ],
    data:() => ({
        informacion: [],
        search: []
    }),
    methods:{
        getUsers(){
            const llaves = Object.keys(this.users).sort()
            const arreglo = []
            llaves.forEach(element => {
                let obj = {
                    nombre: element,
                    info: this.users[element]
                }
                arreglo.push(obj)
            })
            this.informacion = arreglo
        },
        getDays(dia){
            const dias = dia.split(',')
            const days = []
            dias.forEach(element =>{
                if(element == 'l'){
                    days.push('Lunes')
                }else if(element == 'm'){
                    days.push('Martes')
                }else if(element == 'mi'){
                    days.push('Miércoles')
                }else if(element == 'j'){
                    days.push('Jueves')
                }else if(element == 'v'){
                    days.push('Viernes')
                }else if(element == 's'){
                    days.push('Sabado')
                }else if(element == 'd'){
                    days.push('Domingo')
                }
            })
            return days.join(', ')
        },
        getBuscador(){
            const info = this.informacion
            info.forEach(i => {
                this.search.push('')
            })
        }
    },
    watch:{
        users(){
            this.informacion = []
            this.getUsers()
            this.getBuscador()
        },
        informacion(){
            this.getBuscador()
        }
    }
}
</script>
<style>

.divisionLineas:not(:last-child){
    border-bottom: 1px solid #cccccc; 
}
.divisionLineasTop:not(:first-child):not(:nth-of-type(2)){
    border-top: 1px solid #e7e7e7; 
}
</style>

<style lang="scss" scoped>
summary {
	background-color: #fff;
	position: relative;
	cursor: pointer;
	padding: 1em .5em;
    display: flex;
    align-items: center;
	list-style: none; // Remove arrow
	&::-webkit-details-marker {
		display: none; // Remove arrow
	}
	
	&:hover {
		background-color: #f2f5f9;
        border-radius: 7px;
	}
	
	h5 {
		display: flex;
		flex-direction: column;
	}
	small {
		color: #999;
		font-size: .875em;
	}
	
	strong {
		font-weight: 700;
	}
	
	span:first-child {
		width: 2rem;
		height: 2rem;
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		margin-right: 0.9em;
	}
	
	&:focus {
		outline: none;
	}
	
	.plus {
		color: #289672;
	}
}

</style>
<style scoped>
.permisos details, .tableModulo{
    width: 100%;
}
.tableModulo tr th{
    background: #efefef;
    padding: 6px 10px;
}
.tableModulo tr th span{
    font-size: 12px;
}
.tableModulo tr td{
    font-size: 12px;
}
.alinearTexto{
    padding: 6px 10px;
    background: #fdfdfd !important;
}
.alinearTexto p{
    margin:0 !important;
}
.divisionLineasPadres:not(:last-child){
    border-bottom: 2px solid #ececec;
}
</style>
<style lang="scss" scoped>
@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.mini-icon {
     font-size: 0.7rem !important;
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}

.permisos{
    .encabezado{
        border-radius: 14px 14px 0 0;
        background: #F4F7F8;
        padding: 10px 12px;
    }
    .sinInfo{
        padding: 20px;
        text-align: center;
    }
    details{
        padding: 0px;
    }
    details:not(:last-child){
        border-bottom: 2px solid #ececec;
    }
    details summary{
    font-size: 15px;
    }

    .cardDiv{
        border: 1px solid #efeeee;
        border-radius: 7px;
        margin: 0.4rem 0.6rem;
        padding: 1rem 1.2rem;
    }
    hr.hrDot {
        border-top: 1px dotted #e6e6e6;
    }
}
</style>
<style>
.permisos div.vs-table-content > div.vs-table > table{
        margin: 0 auto !important;
        width: 98% !important;
}
</style>

        